import {ReactNode} from 'react';

export interface ToastMessage {
  title?: string;
  message: string | ReactNode;
}

export enum ToastType {
  Info = 'info',
  Error = 'error',
  Success = 'success',
  Warning = 'warning',
}
